export default {
      id: "tag-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#tag",
      toString: function () {
        return this.url;
      }
    }